exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-content-panel {\n  padding-top: 40px;\n  padding-bottom: 40px;\n  background-color: #F5F8F9; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/auth-shell/auth-shell.component.scss
// module id = ../../../../../src/app/auth-shell/auth-shell.component.scss
// module chunks = main